
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18891.084 -24285.699 16.398 11.398"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_169_1","data-name":"Symbol 169 – 1","transform":"translate(-19907.385 -25510)","opacity":".74"}},[_c('g',{attrs:{"id":"Group_7744","data-name":"Group 7744","transform":"translate(1017 1225)"}},[_c('ellipse',{staticClass:"cls-2",attrs:{"id":"Ellipse_884","cx":"2.536","cy":"2.536","data-name":"Ellipse 884","rx":"2.536","ry":"2.536","transform":"translate(4.964 2.464)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3399","d":"M2 7c1.071-2.786 4.679-5 7.5-5A8.894 8.894 0 0 1 17 6.929","data-name":"Path 3399","transform":"translate(-2 -2)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3400","d":"M2 16c1.071 2.786 4.679 5 7.5 5a8.894 8.894 0 0 0 7.5-4.929","data-name":"Path 3400","transform":"translate(-2 -11)"}})])])])
          )
        }
      }
    